import { Bank } from "@/constants/SvgConstants"
import "./style.sass"
interface Props {
  title: string
}
export const PageTitle = ({ title }: Props) => {
  return (
    <div className="payments-titlebar">
      <div className="text-sm payments-titlebar__desc flex gap-2 items-start lg:items-center mb-6">
        <div>
          <Bank />
        </div>
        Unlock the full potential of your banking. Enjoy fast, secure payments and seamless transfer management in one place.
      </div>
      <h1>{title}</h1>
    </div>
  )
}
